// extracted by mini-css-extract-plugin
export default {"tcoButton":"fV_oE-","tcoButtonDisabled":"_1gtEXd"};